export default "__VITE_ASSET__DIDwJykn__"